import { render } from "./PollForm.vue?vue&type=template&id=c996ee3a"
import script from "./PollForm.vue?vue&type=script&lang=js"
export * from "./PollForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__